import DomManipulate from './DomManipulate';
let MobileDetect = new (require('mobile-detect'))(window.navigator.userAgent);

export default class RfkitsFinder {
    constructor(rfkitSelect, rfkitsList, rfkitsItem, msg) {
        this.rfkitSelect = rfkitSelect
        this.rfkitsItem = rfkitsItem
        this.rfkitsList = rfkitsList
        this.msg = msg
    }

    init() {
        const dom = new DomManipulate();
        dom.onReady(() => {
            let dropdownArr = document.querySelectorAll(this.rfkitSelect)
            this.updateRfkitList(dropdownArr)
            dropdownArr.forEach(element => {
                element.addEventListener('change', () => {
                    this.updateRfkitList(dropdownArr)
                })
            });
            // Listen for resize changes
            window.addEventListener("resize", () => {
                this.updateRfkitList(dropdownArr)
            });
        })
    }

    // hide and show item in fact of selected dropdown value 
    updateRfkitList(dropdownArr) {
        let filters = {}
        dropdownArr.forEach(element => {
            filters[element.getAttribute('name')] = element.options[element.selectedIndex].value
        });
        let rfkitsItemArr = document.querySelectorAll(this.rfkitsItem)
        rfkitsItemArr.forEach(rfitem => {

            let passedFilterTest = true;
            for (let key in filters) {
                if (filters[key] && rfitem.getAttribute('data-filter-' + key) != filters[key]) {
                    passedFilterTest = false;
                }
            }
            rfitem.classList.remove('tile-reset');
            if (passedFilterTest) {
                rfitem.classList.remove('d-none');
                rfitem.classList.add('tile-set');
            } else {
                rfitem.classList.add('d-none');
                rfitem.classList.remove('tile-set');
            }
        });
        this.reorganizeGrid()
    }

    reorganizeGrid() {
        let listItemsShowArr = document.querySelectorAll(this.rfkitsItem + ':not(.d-none)')
        document.querySelector('.msg').innerHTML = ''
        console.log(listItemsShowArr)
        if (listItemsShowArr.length <= 0) {


            let txtMsg = ''
            if (document.documentElement.lang == 'fr') {
                txtMsg = 'Pas de résultats à afficher'
            } else {
                txtMsg = 'No results to display'
            }
            document.querySelector('.msg').innerHTML = txtMsg

        } else {
            let counter = 0
            listItemsShowArr.forEach(element => {
                element.classList.remove('tile-first')

                if (counter == 0) {
                    element.classList.add('tile-first')
                }

                counter++

                if (MobileDetect.tablet()) {
                    if (window.innerWidth >= 1024) {
                        if (counter >= 5) {
                            counter = 1
                            element.classList.add('tile-reset')
                        }
                    } else {
                        if (counter >= 2) {
                            counter = 0
                        }
                    }
                } else {
                    if (counter >= 5) {
                        counter = 1
                        element.classList.add('tile-reset')
                    }
                }
            });
        }
    }
}